import {ActionTypes} from "../contants/action-type.js";
import {
    getCuisines,
    createCuisine,
    updateCuisine,
    deleteCuisine,
    getSelectedCuisine,
    changeStatusCuisine
} from '../../services/CuisineService.js';

export function getCuisineAction() {
    return (dispatch, getState) => {
        getCuisines().then((response) => {
            dispatch(listCuisines(response.data));
        });
    };
}

export function getSelectedCuisineAction(id) {
    return (dispatch, getState) => {
        getSelectedCuisine(id).then((response) => {
            dispatch(selectedCuisine(response.data));
        });
    };
}
export function createCuisineAction(cuisine, history) {
    return (dispatch, getState) => {
        createCuisine(cuisine).then((response) => {
            dispatch(confirmCreateCuisine(response.data));
            history.push('/item/cuisine');
        });
    };
}
export function updateCuisineAction(cuisine,id, history) {
    return (dispatch, getState) => {
        console.log(cuisine);
        updateCuisine(cuisine,id).then((response) => {
            dispatch(confirmEditCuisine(response.data));
            history.push('/item/cuisine');
        });
    };
}
export function changeStatusCuisineAction(cuisine, id, history) {
    return (dispatch, getState) => {
        changeStatusCuisine(cuisine, id).then((response) => {
            dispatch(listCuisines(response.data));
            history.push('/item/cuisine');
        });
    };
}
export function deleteCuisineAction(id, history) {
    return (dispatch, getState) => {
        deleteCuisine(id).then((response) => {
            dispatch(listCuisines(response.data));
            history.push('/item/cuisine');
        });
    };
}
export const listCuisines = (cuisines) => {
    return {
        type: ActionTypes.LIST_CUISINE,
        payload: cuisines
    }
}
export const confirmCreateCuisine = (cuisine) => {
    return {
        type: ActionTypes.CONFIRM_CREATE_CUISINE,
        payload: cuisine
    }
}
export const confirmEditCuisine = (cuisine) => {
    return {
        type: ActionTypes.CONFIRM_EDIT_CUISINE,
        payload: cuisine
    }
}
export const selectedCuisine = (cuisine) => {
    return {
        type: ActionTypes.SELECTED_CUISINE,
        payload: cuisine
    }
}
export const confirmDeleteCuisine = (cuisine) => {
    return {
        type: ActionTypes.CONFIRM_DELETE_CUISINE,
        payload: cuisine
    }
}